import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { SettingsProvider } from "./components/settings/SettingsProvider";
import "./styles/global.css";
import "./styles/premium-home.css";
import "./styles/platform-refinements.css";
import "./styles/hero-cinematic.css";
import "./styles/khalili-cinematic.css";
import "./styles/manasik-map.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Athkari root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </StrictMode>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
